var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.logoSrc)?_c('v-avatar',{staticClass:"wgu-app-logo",attrs:{"width":_vm.logoWidth,"height":_vm.logoHeight,"tile":true}},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":_vm.$t('app.logo')}})]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-119d8dba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLogo.vue
// module id = 4uSC
// module chunks = 1